import { useEffect } from 'react';

import type { TasksPeriod } from '../types';
import type { MutableRefObject } from 'react';

interface UseTasksPeriodPickerEffectsParams {
  draftPeriod: TasksPeriod | null;
  closeGuardRef: MutableRefObject<boolean>;
}

export const useTasksPeriodPickerEffects = ({
  draftPeriod,
  closeGuardRef,
}: UseTasksPeriodPickerEffectsParams) => {
  // Защита действует только в том событии, где выбрана вторая дата: после
  // отрисовки нового черновика закрытие снаружи снова закрывает календарь.
  useEffect(() => {
    closeGuardRef.current = false;
  }, [draftPeriod, closeGuardRef]);
};
